import { memo } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

const HeatmapSingleSensorList = ({ sensors, onChange }: any) => {
    const removeSensor = (sensor: any) => {
        const updatedSensors = sensors.filter(
            (item: any) => item.device_id !== sensor.device_id
        );
        if (typeof onChange === "function") {
            onChange(updatedSensors);
        }
    };

    const handleChangeChartName = (event: any, sensor: any) => {
        const updatedSensors = sensors.map((item: any) => {
            if (item.device_id === sensor.device_id) {
                return {
                    ...item,
                    chart_name: event.target.value,
                };
            }
            return item;
        });
        if (typeof onChange === "function") {
            onChange(updatedSensors);
        }
    };

    if (!sensors?.length) {
        return <></>;
    }

    return (
        <Row className="cstm-table heatmap-sensor-table">
            <Col sm={12}>
                <div className="table-head">
                    <Row className="no-checkbox">
                        <Col xs={{ span: 2 }}>Sensor</Col>
                        <Col xs={{ span: 2 }}>Chart Name</Col>
                        <Col xs={{ span: 2 }}>Type</Col>
                        <Col xs={{ span: 2 }}>Gateway</Col>
                        <Col xs={{ span: 2 }}>UUID</Col>
                        <Col xs={{ span: 1 }}> </Col>
                    </Row>
                </div>
                {(sensors || []).map((sensor: any) => (
                    <div className="table-row" key={sensor.device_id}>
                        <Row className="no-checkbox">
                            <Col xs={{ span: 2 }}>{sensor.device_name}</Col>
                            <Col xs={{ span: 2 }}>
                                <Form.Control
                                    type="text"
                                    defaultValue={sensor.device_name || ""}
                                    placeholder=""
                                    onChange={(event) =>
                                        handleChangeChartName(event, sensor)
                                    }
                                />
                            </Col>
                            <Col xs={{ span: 2 }}>{sensor.sensor_type}</Col>
                            <Col md={{ span: 2 }}>{sensor.gatewayName}</Col>
                            <Col md={{ span: 2 }}>{sensor.ldsu_uuid}</Col>
                            <Col md={{ span: 2 }} className="text-right">
                                <Button
                                    variant="link"
                                    className="p-0 text-decoration-none"
                                    onClick={() => removeSensor(sensor)}
                                >
                                    <i className="material-icons close-icon d-flex">
                                        close
                                    </i>
                                </Button>
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </Row>
    );
};

export default memo(HeatmapSingleSensorList);
